import { Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import * as flags from "country-flag-icons/react/3x2";
import { Country } from "react-phone-number-input";

import { $ok } from "foundation-ts/commons";

interface CustomCountrySelectProps {
    options: { value: Country; label: string }[];
    value?: Country;
    disabled?: boolean;
    onChange: (country: Country) => void;
}

export const CustomCountrySelect = (props: CustomCountrySelectProps) => {
    const { disabled, options, value, onChange } = props;
    const SelectedFlag = $ok(value) ? (flags as any)[value!] : null;

    return (
        <Menu >
            <MenuButton
                type="button"
                width="40px"
                height="40px"
                borderRadius="md"
                display="flex"
                disabled={disabled}
                alignItems="center"
                justifyContent="center"
                _hover={{ borderColor: "gray.300" }}
            >
                { SelectedFlag && <SelectedFlag style={{ width: 28, height: 20, borderRadius: 2 }} /> }
            </MenuButton>
            <MenuList maxHeight="240px" overflowY="auto" minWidth="60px">
                {options
                    .filter(option => !!option.value)
                    .map(option => {
                        const Flag = (flags as any)[option.value];
                        return (
                            <MenuItem
                                key={option.value}
                                onClick={() => onChange(option.value)}
                                display="flex"
                                justifyContent="center"
                                paddingY="6px"
                            >
                                { Flag && <Flag style={{ width: 28, height: 20, borderRadius: 2 }} /> }
                            </MenuItem>
                        );
                    })}
            </MenuList>
        </Menu>
    );
};